import { createVuetify } from "vuetify";
import * as components from "vuetify/lib/components";
import * as directives from "vuetify/lib/directives";
import { th, en } from "vuetify/locale";
import "vuetify/styles";
import "@/styles/global-styles.scss";
import "@mdi/font/css/materialdesignicons.css";

const KMITLTheme = {
  dark: false,
  colors: {
    background: "#FFFFFF",
    surface: "#FFFFFF",
    "surface-bright": "#FFFFFF",
    "surface-light": "#EEEEEE",
    "surface-variant": "#424242",
    "on-surface-variant": "#EEEEEE",
    primary: "#F2500B",
    // primary: "#E35205",
    "primary-dark": "#942C00",
    "primary-light": "#FF966A",
    secondary: "#6C757D",
    "secondary-dark": "#54595E",
    "secondary-light": "#ABB5BE",
    error: "#DC3545",
    info: "#17A2B8",
    success: "#28A745",
    warning: "#FFC107",
    "alert-success-text": "#0a3622",
    "alert-success-bg": "#d1e7dd",
    "alert-success-border": "#75b798",
    "alert-danger-text": "#58151c",
    "alert-danger-bg": "#f8d7da",
    "alert-danger-border": "#ea868f",
    "alert-warning-text": "#664d03",
    "alert-warning-bg": "#fff3cd",
    "alert-warning-border": "#ffda6a",
    "alert-info-text": "#055160",
    "alert-info-bg": "#cff4fc",
    "alert-info-border": "#6edff6",
    "tag-bg-1": "#d1e7dd",
    "tag-bg-2": "#cfe2ff",
    "tag-bg-3": "#e0cffc",
    "tag-bg-4": "#ffe5d0",
    "tag-bg-5": "#fff3cd",
    "tag-bg-6": "#d2f4ea",
    "tag-bg-7": "#e2d9f3",
    "tag-bg-8": "#f7d6e6",
    "tag-bg-9": "#cff4fc",
    "tag-bg-10": "#f8d7da",
    "tag-text-1": "#0A3622",
    "tag-text-2": "#052C65",
    "tag-text-3": "#290661",
    "tag-text-4": "#653208",
    "tag-text-5": "#664D03",
    "tag-text-6": "#0d503c",
    "tag-text-7": "#2c1a4d",
    "tag-text-8": "#561435",
    "tag-text-9": "#055160",
    "tag-text-10": "#58151c",
    "rich-black": "#3b3939",
  },
};

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: "KMITLTheme",
    themes: {
      KMITLTheme,
    },
  },
  locale: {
    messages: { th, en },
  },
});
